import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useCurrentUser } from "@/data/auth/hooks";
import { Inbox, InboxContent } from "@novu/react";
import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";

interface NovuInboxProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export function NovuInbox({ open, onOpenChange }: NovuInboxProps = {}) {
  const navigate = useNavigate();
  const { data: currentUserData } = useCurrentUser();

  // Use internal state if no external state is provided
  // Always declare hooks at the top level, before any conditional logic
  const [isOpenInternal, setIsOpenInternal] = useState(false);

  // Determine if we're using controlled or uncontrolled state
  const isControlled = open !== undefined && onOpenChange !== undefined;
  const isOpen = isControlled ? open : isOpenInternal;
  const setIsOpen = isControlled ? onOpenChange : setIsOpenInternal;

  // Early return after hooks are declared
  if (!currentUserData) {
    return null;
  }

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen} modal={true}>
      <DialogContent className="max-w-lg h-[600px] overflow-hidden p-0 [&>button]:hidden">
        <DialogTitle className="px-6 pt-4 border-b hidden">
          Notifications
        </DialogTitle>

        <div className="w-full h-full">
          <Inbox
            applicationIdentifier={
              process.env.NODE_ENV === "development"
                ? "bt9yrvaEDBk9"
                : "TvtmTMqKVoUD"
            }
            subscriberHash={currentUserData.novuSubHashedId}
            subscriber={{
              subscriberId: currentUserData.id,
              firstName: currentUserData.firstName,
              lastName: currentUserData.lastName,
              email: currentUserData.email,
            }}
            routerPush={(path: string) => {
              setIsOpen(false);
              navigate({ to: path });
            }}
            appearance={{
              variables: {
                colorPrimary: "#DD2450",
                colorForeground: "#0E121B",
                fontSize: "18px",
              },
            }}
          >
            <div className="w-full h-full overflow-hidden">
              <InboxContent />
            </div>
          </Inbox>
        </div>
      </DialogContent>
    </Dialog>
  );
}
